<template>
  <div class="flex flex-col">
    <div @click="toggle" :class="{'cursor-pointer': !preventDefaultBarOpen}">
      <slot name="header">
        <div :class="headerClass">
          {{ header }}
          <div v-if="icon" :class="open ? openIconClass:closeIconClass">
            <i :class="icon"></i>
          </div>
        </div>
      </slot>
    </div>
    <transition name="accordion">
      <div v-if="open">
        <slot></slot>
      </div>
    </transition>
    <div v-if="validSlot('closed') && !open">
      <slot name="closed"></slot>
    </div>
  </div>
</template>


<script>

export default {
  name: "RpmAccordion",
  data() {
    return {
      open: false,
    };
  },
  props: {
    preventDefaultBarOpen:{
      type: Boolean,
      default: false
    },
    absoluteOpen: {
      type: Boolean,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    openIconClass: {
      type: String,
      default: ''
    },
    closeIconClass: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    headerClass: {
      type: [String, Array, Object],
      default: ''
    },
  },
  methods: {
    toggle() {
      if(!this.disable && !this.preventDefaultBarOpen) this.open = !this.open;
    },
    externalOpen(val){
      if(!this.disable && typeof val === 'boolean') this.open = val;
    },
    validSlot(slot) {
      return !!this.$slots[slot];
    },
  },
  watch: {
    absoluteOpen(val){
      this.externalOpen(val);
    },
  },
  mounted(){
    this.externalOpen(this.absoluteOpen);
  }
};

</script>

<style scoped>
.accordion-enter-from {
  @apply max-h-0;
}
.accordion-enter-active {
  @apply overflow-hidden transition-[max-height] duration-1000 ease-[cubic-bezier(0.42,0,0.58,1)];
}
.accordion-enter-to {
  @apply max-h-[1000px];
}

.accordion-leave-from {
  @apply max-h-[1000px];
}
.accordion-leave-active {
  @apply overflow-hidden transition-[max-height] duration-[450ms] ease-[cubic-bezier(0,1,0,1)];
}
.accordion-leave-to {
  @apply max-h-0;
}

</style>
